export default {"src":"/_next/static/media/white_finger.3b5da709.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};